<template>
   <div>
        <div class="card org-header">
            <div class="card-body">
                <div class="">
                    <div class="row">
                        <div class="col-md-1">
                            <img src="@/assets/img/vue-logo.png" class="img-thumbnail">
                        </div>
                        <div class="col-md-5">
                            <h1 class="fw-bold">{{ org.name }}</h1>
                            Launched on {{ org.date_created }}
                            <div class="card mt-2" v-if="apiToken">
                                <div class="card-body">
                                    <h6 class="card-title">API Token</h6>
                                    <code>{{ apiToken }}</code>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <div class="row" v-if="isSuperAdmin || isPentester">
                                <div class="col text-end">
                                    <a href="javascript:void(0)"
                                        data-bs-toggle="modal"
                                        data-bs-target="#addProject"
                                        v-on:click="refresh = Math.random()"
                                        class="btn ps-4 pe-4 fw-bold btn-outline-info rounded-pill">New Test</a>
                                </div>
                                <div class="col">
                                    <button class="btn ps-4 pe-4 fw-bold btn-outline-info rounded-pill" v-on:click="generateToken">Generate API Token</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-4 pt-4">
                 <div class="mt-4">
                    <div class="row">
                        <div class="col-12">
                            <h3 class="text-default mb-4 fw-bold">Summary of Vulnerabilities Detected</h3>
                            <div class="table-responsive">
                                <table class="table text-center">
                                    <thead>
                                       <tr class="table-light text-default">
                                          <th class="text-start">Test</th>
                                          <th class="text-center">Status</th>
                                          <th class="vtx-insignificant">Insignificant</th>
                                          <th class="vtx-low">Low</th>
                                          <th class="vtx-medium">Medium</th>
                                          <th class="vtx-high">High</th>
                                          <th class="vtx-veryhigh">Very High</th>
                                          <th class="text-center">Total Vulnerabilities</th>
                                          <th class="text-center">Actions Recommended</th>
                                          <!-- <th class="text-center">Retest Results</th> -->
                                       </tr>
                                    </thead>
                                   <tbody v-if="projectsList.length != 0">
                                      <tr v-for="list in projectsList" v-bind:key="list.ID">
                                         <td  class="text-start" width="20%">
                                            <a href="javascript:void(0)"
                                                data-bs-toggle="tooltip"
                                                data-bs-title="project title"
                                                class="text-default"
                                                v-on:click="setActiveProd(list.id, list.title, '/' + org_id +'/vulnerability/' + list.id)">
                                            {{ list.title }}
                                            </a>
                                         </td>
                                         <td>
                                            <span v-if="list.status == 1" class="badge bg-warning">In Progress</span>
                                            <span v-if="list.status == 5" class="badge bg-info">Not Started</span>
                                            <span v-if="list.status == 4" class="badge bg-danger">Cancelled</span>
                                            <span v-if="list.status == 2" class="badge bg-success">Completed</span>
                                            <span v-if="list.status == 3" class="badge bg-secondary">Archived</span>
                                         </td>
                                         <td>{{ list.insignificant }}</td>
                                         <td>{{ list.low }}</td>
                                         <td>{{ list.medium }}</td>
                                         <td>{{ list.high }}</td>
                                         <td>{{ list.very_high }}</td>
                                         <td>{{ list.report_total }}</td>
                                         <td>{{ list.action_total }}</td>
                                      </tr>
                                   </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                 </div>
                </div>
            </div>
        </div>

      <div class="modal" id="addProject" tabindex="-2" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3>New Test</h3>
                        <button type="button" id="closeProject" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <ProjectsForm v-if="refresh != 0" title="Create" v-on:callback="formCallback" :project_id="project_id" :key="refresh"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="requestPentest" tabindex="-2" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3>Select Test Type</h3>
                        <button type="button" id="closeProject" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-4">
                                <button class="btn ps-4 pe-4 fw-bold btn-outline-info rounded-pillw-100 btn-lg">
                                    <i class="fas fa-globe-americas me-2"></i>Website
                                </button>
                            </div>
                            <div class="col-md-4">
                                <button class="btn ps-4 pe-4 fw-bold btn-outline-info rounded-pill w-100 btn-lg">
                                    <i class="fas fa-mobile-alt me-2"></i> Mobile App
                                </button>
                            </div>
                            <div class="col-md-4">
                                <button class="btn ps-4 pe-4 fw-bold btn-outline-info rounded-pill w-100 btn-lg">
                                    <i class="fas fa-wifi me-2"></i> WiFi
                                </button>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-4">
                                <button class="btn ps-4 pe-4 fw-bold btn-outline-info rounded-pill w-100 btn-lg">
                                    <i class="fas fa-code me-2"></i>API
                                </button>
                            </div>
                            <div class="col-md-4">
                                <button class="btn ps-4 pe-4 fw-bold btn-outline-info rounded-pill w-100 btn-lg">
                                    <i class="fas fa-network-wired me-2"></i>Infrastructure
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
   </div>
</template>
<script>
   // import Timeline from 'timeline-vuejs'
   import ProjectsForm from '@/views/Project/projectForm.vue'
   import { mapGetters } from 'vuex';

   export default {
     components: {
        // Timeline,
        ProjectsForm
     },
     computed: {
        ...mapGetters('auth', ['isSuperAdmin', 'isPentester']),
     },
     data () {
       return {
         projectsList: [],
         org_id : this.$route.params.org_id,
         project_id: 0,
         team: [],
         team_popups: false,
         email : '',
         refresh: 0,
         org: '',
         apiToken: null
       }
     },
     mounted() {
       this.init();
     },
     methods: {
       setActiveProd(id, title, link) {
         localStorage.setItem('SubSidebar', true);
         localStorage.setItem('SelectedProject', id);
         this.$router.push({ path: link, query: { project_name: title } });
       },

       init() {

         const me = this;
         this.$axios({
            method: 'get',
            url: this.$server + 'organisation/' + this.$route.params.org_id
        })
        .then(res => {
            this.org = res.data.organisation;
        });

         this.$axios({
           method: 'get',
           url: this.$server + 'organisation/'+ me.$route.params.org_id +'/project',
         })
         .then(res => {
           var r = res.data;
           if (r.success) {
               me.projectsList = r.data;
           }
         });
       },

       generateToken() {
        const me = this;
        this.$axios({
             method: 'post',
             url: this.$server + 'organisation/'+ me.$route.params.org_id +'/generate/token',
         })
         .then(res => {
            if (res.data.success) {
                me.apiToken = res.data.token
            }
         });
       },

       formCallback(res) {
            if (res == true) { // any random value return true
                this.init();
                document.getElementById("closeProject").click();
            }
        },
       removeTeam: function(id) {
           const me = this;
           if (confirm("Are you sure you want to remove?")) {
             this.$axios({
                 method: 'post',
                 url: this.$server + 'organisation/'+ me.$route.params.org_id +'/team',
                 data: JSON.stringify({
                     'user_id' : id
                 })
             })
             .then(res => {
                 var r = res.data;
                 if (r.success) {
                     me.$notifications.notify({
                         message: '<span>' + r.message + '</span>',
                         icon: 'fa fa-check',
                         type: 'success'
                     });

                     me.init();
                 }
             });
           }
       },

       invite: function() {
         const me = this;
         this.$axios({
               method: 'post',
               url: this.$server + 'organisation/'+ me.$route.params.org_id +'/team/invites',
               data: JSON.stringify({
                   'email' : me.email
               })
           })
           .then(res => {
               var r = res.data;
               if (r.success) {
                   me.$notifications.notify({
                       message: '<span>' + r.message + '</span>',
                       icon: 'fa fa-check',
                       type: 'success'
                   });

                   me.init();
               }
           });
       }
     }
   }
</script>